import React, { useState } from 'react';
import RoomReserve from './RoomReserve';
import PropertyList from './PropertyList';
import { useSelector } from 'react-redux';
import ProgressSteps from './ProgressSteps';

const SearchPage = () => {
  const checkInDate = useSelector((state) => state.selectedDates.checkInDate);
  const checkOutDate = useSelector((state) => state.selectedDates.checkOutDate);

  // ⬅️ selectedFactors now stores factor IDs (from API), not string keys
  const [selectedFactors, setSelectedFactors] = useState([]);
  // ⬅️ allFactors hoisted to parent so both children share the same data
  const [allFactors, setAllFactors] = useState([]);

  const calculateCorrectDates = (checkin, checkout) => {
    if (!checkin) return {};

    let checkinDate = new Date(checkin);
    let checkoutDate = new Date(checkout);

    if (!checkout || checkoutDate <= checkinDate) {
      checkoutDate = new Date(checkinDate);
      checkoutDate.setDate(checkinDate.getDate() + 1);
    }

    return {
      checkin_date: checkinDate.toISOString().split('T')[0],
      checkout_date: checkoutDate.toISOString().split('T')[0],
    };
  };

  const correctedDates = calculateCorrectDates(checkInDate, checkOutDate);

  return (
    <div className="min-h-screen p-4 mt-16 relative">
      <ProgressSteps currentStep={1} />
      <RoomReserve
        selectedFactors={selectedFactors}
        setSelectedFactors={setSelectedFactors}
        allFactors={allFactors}
        setAllFactors={setAllFactors}
      />
      <PropertyList
        dates={correctedDates}
        selectedFactors={selectedFactors}
        allFactors={allFactors}
      />
    </div>
  );
};

export default SearchPage;

// import React from 'react';
// import RoomReserve from './RoomReserve';
// import PropertyList from './PropertyList';
// import { useSelector } from 'react-redux';
// import ProgressSteps from './ProgressSteps';

// const SearchPage = () => {
//   // Get dates directly from Redux
//   const checkInDate = useSelector((state) => state.selectedDates.checkInDate);
//   const checkOutDate = useSelector((state) => state.selectedDates.checkOutDate);

//   const calculateCorrectDates = (checkin, checkout) => {
//     if (!checkin) return {};

//     let checkinDate = new Date(checkin);
//     let checkoutDate = new Date(checkout);

//     if (!checkout || checkoutDate <= checkinDate) {
//       checkoutDate = new Date(checkinDate);
//       checkoutDate.setDate(checkinDate.getDate() + 1);
//     }

//     return {
//       checkin_date: checkinDate.toISOString().split('T')[0],
//       checkout_date: checkoutDate.toISOString().split('T')[0],
//     };
//   };

//   const correctedDates = calculateCorrectDates(checkInDate, checkOutDate);

//   return (
//     <div className="min-h-screen p-4 mt-16 relative">
//       <ProgressSteps currentStep={1} />
//       <RoomReserve />
//       <PropertyList dates={correctedDates} />
//     </div>
//   );
// };

// export default SearchPage;
